import { render, staticRenderFns } from "./MVLiveLogo.vue?vue&type=template&id=0a40d8d0&scoped=true&"
import script from "./MVLiveLogo.vue?vue&type=script&lang=js&"
export * from "./MVLiveLogo.vue?vue&type=script&lang=js&"
import style0 from "./MVLiveLogo.vue?vue&type=style&index=0&id=0a40d8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40d8d0",
  null
  
)

export default component.exports